// extracted by mini-css-extract-plugin
module.exports = {"date-range":"DateRange--date-range--2JWFr","dateRange":"DateRange--date-range--2JWFr"};